export default {
  SuffixAutocomplete__NO_MATCH_FOUND: "No match found",
};
